import { render, staticRenderFns } from "./ColorStyleSetting.vue?vue&type=template&id=1ea3191f&"
import script from "./ColorStyleSetting.vue?vue&type=script&lang=js&"
export * from "./ColorStyleSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports